
import { supabase } from "@/integrations/supabase/client";

export interface GalleryPhoto {
  id: string;
  title: string;
  description: string;
  file_path: string;
  alt_text: string;
  sort_order: number;
}

export interface PhotoGallery {
  id: string;
  name: string;
  description: string;
  slug: string;
  sort_order: number;
  is_active: boolean;
}

export const galleryService = {
  async getGalleryPhotos(gallerySlug: string): Promise<GalleryPhoto[]> {
    try {
      const { data, error } = await supabase.rpc('get_gallery_photos', {
        gallery_slug: gallerySlug
      });

      if (error) {
        console.error('Error fetching gallery photos:', error);
        throw error;
      }

      return data || [];
    } catch (error) {
      console.error('Gallery service error:', error);
      throw error;
    }
  },

  async getAllGalleries(): Promise<PhotoGallery[]> {
    try {
      const { data, error } = await supabase
        .from('photo_galleries')
        .select('*')
        .eq('is_active', true)
        .order('sort_order');

      if (error) {
        console.error('Error fetching galleries:', error);
        throw error;
      }

      return data || [];
    } catch (error) {
      console.error('Gallery service error:', error);
      throw error;
    }
  }
};
